// tslint:disable-next-line:variable-name
export const es_MX = {
  child: 'niño',
  CARDIOVASCULAR_RISK: 'relación IMC / ICC ',
  imc_classification_child: 'clasificación IMC niño',
  IMC_CLASSIFICATION_CHILD: 'clasificación IMC niño',
  imc_adult: 'IMC adulto',
  imc_children: 'IMC niños',
  imc: 'IMC',
  ideal_weight: 'peso ideal',
  ideal_weight_devine_man: 'peso ideal hombre - Devine',
  ideal_weight_devine_woman: 'peso ideal mujer - Devine',
  ideal_weight_lorentz_man: 'peso ideal hombre - Lorentz',
  ideal_weight_lorentz_woman: 'peso ideal mujer - Lorentz',
  tmb: 'tasa metabólica basal',
  tmb_harris_benedict_man: 'TMB hombre - Harris Benedict',
  tmb_harris_benedict_woman: 'TMB mujer - Harris Benedict',
  geb: 'gasto energético basal',
  geb_mifflin_st_jeor_man: 'GEB hombre - Mifflin St. Jeor',
  geb_mifflin_st_jeor_woman: 'GEB mujer - Mifflin St. Jeor',
  'geb_fao/oms_man': 'GEB HOMBRE - FAO/OMS',
  'geb_fao/oms_woman': 'GEB MUJER - FAO/OMS',
  'geb_valencia_man': 'GEB hombre - Valencia',
  'geb_valencia_woman': 'GEB mujer - Valencia',
  'waist_to_hip_ratio': 'relación cintura-cadera',
  'get': 'Gasto energético total',
};

